import { HttpData, HttpNoData } from "../../../Core";

export const createMachineAsync = async (body, jwt) => {
    const response = await HttpData(`/api/v0/lasers/create`, 'POST', jwt, body)

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export const updateMachineAsync = async (id, body, jwt) => {
    const response = await HttpData(`/api/v0/lasers/update/${id}`, 'PUT', jwt, body)

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}
